import styled from '@emotion/styled';

const MenuList = styled.ul({
  display: 'flex',
  flexWrap: 'wrap',
  margin: 0,
  padding: '1rem 0',
  listStyle: 'none',
  fontFamily: 'Noto Sans KR, sans-serif',
  fontSize: '2.4rem',
  fontWeight: 'bold',
});

export default MenuList;
